import { useEffect, useRef, useState } from "react";
import { Menu } from "@mui/icons-material";
import classNames from "classnames";
import styles from "./CustomNav.module.scss";
import { Link } from "react-router-dom";

export default function Nav({ contentRef }) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolledUp, setIsScrolledUp] = useState(false);
  const lastScroll = useRef(contentRef?.current?.scrollTop ?? 0);

  useEffect(() => {
    if (!contentRef.current) return;

    function onScroll() {
      setIsScrolled(contentRef.current.scrollTop > 0);
      setIsScrolledUp(contentRef.current.scrollTop < lastScroll.current);
      lastScroll.current = contentRef.current.scrollTop;
    }

    contentRef.current.addEventListener("scroll", onScroll);

    return () => contentRef.current?.removeEventListener("scroll", onScroll);
  }, [contentRef]);

  return (
    <div
      className={classNames(styles.nav, {
        [styles.scrolled]: isScrolled,
        [styles.scrolledUp]: isScrolledUp,
      })}
    >
      <a href="/">
        <img
          alt="home"
          className={styles.logo}
          src="/img/svg_icons/clear_logo.png"
        />
      </a>

      <div
        className={classNames(styles.linksWrapper, {
          [styles.open]: isNavOpen,
        })}
      >
        <ul className={classNames(styles.links, { [styles.open]: isNavOpen })}>
          <li>
            <a href="/learning-resources">Learn</a>
          </li>
          <li>
            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}/fasttrack`}>
              Rates
            </Link>
          </li>
          <li>
            <a href="/pre-approval">Pre-Approval</a>
          </li>
          <li>
            <a href="/apply">Apply</a>
          </li>
          <li>
            <a href="/contact">Contact</a>
          </li>

          <li>
            <Link
              to={process.env.REACT_APP_ROUTE_PREFIX}
              className={styles.navButton}
            >
              Build a Quote
            </Link>
          </li>

          <li>
            <a href="#" className={styles.profileButton}>
              <img src="/img/svg_icons/nav_profile.svg" alt="Profile" />
              <span>Log In</span>
            </a>
          </li>
        </ul>
      </div>

      <button
        onClick={() => setIsNavOpen(!isNavOpen)}
        className={classNames(styles.menuButton, {
          [styles.active]: isNavOpen,
        })}
      >
        <Menu />
      </button>
    </div>
  );
}
